import { useLocation, useNavigate } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { InventoryTransactionProvider } from "../../context/InventoryTransactionContext";
import { PermissionsProvider } from "../../../../contexts/PermissionsContext";
import "./InventoryTransaction.css";
import { environment } from "../../../../environments/environment";
import { Wrapper } from "../../../../components/Wrapper/Wrapper";
import { NavBar } from "../../../../components/NavBar/NavBar";
import { DropdownsProvider } from "../../../../contexts/DropdownsContext";
import { PartIssue } from "./PartIssue/PartIssue";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { addTab } from "../../../../redux/features/TabsManager/tabSlice";
//crear componente react
export const InventoryTransaction = () => {
  const location = useLocation();
  const basePath = environment.basePath;
  const { data, type } = location.state || {};

  const navigate = useNavigate();
  const navegation = (path) => {
    navigate(basePath + path);
  };

  const dispatch = useDispatch();
  function generateUUID() {
    return crypto.randomUUID();
  }
  useEffect(() => {

    dispatch(
      addTab({
        icon: "icon-issue",
        color: "#4F79C2",
        path: "/store/inventory-transaction",
        title: "Inventory Transaction",
        isPinned: false,
        componentKey: "InventoryTransaction",
        id: 16,
        isModule: false,
        date: generateUUID(),
      })
    );
  }, []);
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => navigate("/secure/customdashboard")}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => navegation("/store")}
    >
      Store
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Inventory Transaction
    </Link>,
  ];
  return (
    <InventoryTransactionProvider>
      <PermissionsProvider resourceId={14}>
        <div className="inventory-transaction-component">
          <div className="nav-header">
            <NavBar
              dataBreadCrumbs={"/store/inventory-transaction"}
              moduleIcon={"icon-stores"}
              appIcon="icon-issue"
              moduleColor="#4F79C2"
              title={"Manual Entry"}
              menuTitle={"Stores"}
              moduleId={3}

              screenActions={<>
              <Tooltip
                  className="custom-tooltip"
                  title={
                    "The quantity to issue is editable but cannot exceed either the requested amount or the available stock. Please adjust the value within these limits to ensure accurate inventory control."
                  }
                  arrow
                >
                  <div className="information-tooltip">
                    <i className="icon-info"></i>
                    <b>Important Information</b>
                  </div>

                </Tooltip>
                <button className="filled green-toggle">
                  <h2>Post</h2>
                </button>

              </>}
              
            >
              {/* <Tooltip
                  className="custom-tooltip"
                  title={
                    "The quantity to issue is editable but cannot exceed either the requested amount or the available stock. Please adjust the value within these limits to ensure accurate inventory control."
                  }
                  arrow
                >
                  <div className="information-tooltip">
                    <i className="icon-info"></i>
                    <b>Important Information</b>
                  </div>
                </Tooltip> */}
            </NavBar>
            {/* <button className="filled green-toggle">
              <h2>Post</h2>
            </button> */}
          </div>
          <div className="nav-header" style={{ display: 'flex', alignItems: "center" }}>



          </div>
          <div className="inventoryTransactiont-component-content">
            <hr />
            <DropdownsProvider>
              <PartIssue />
            </DropdownsProvider>
          </div>
          <div className="paginator-container"></div>
        </div>
      </PermissionsProvider>
    </InventoryTransactionProvider>
  );
};
